import React, { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';

function ValEstipulado({ finalidade }) {
    const [valorEstipulado, setValorEstipulado] = useState("0.00");
    const [ipraCalculado, setIpraCalculado] = useState(0);
    
    const calcularIpra = (valorEstipulado, finalidade) => {
        var val = valorEstipulado.replaceAll('.', '')
        var macsum = val.replaceAll(',', '')
        const taxa = finalidade === 'habitacao' ? 0.004 : (finalidade === 'comercial' ? 0.007 : 0);
        const ipraCalculado = parseFloat(macsum) * taxa;
        setIpraCalculado(ipraCalculado);
    };

    const handleInputChange = (value) => {
        if (finalidade === null || finalidade === "Escolha a finalidade") {
            alert("Escolha a finalidade.")
        } else {            
            setValorEstipulado(value);
            calcularIpra(value, finalidade);
        }
    };

  

    useEffect(() => {
        calcularIpra(valorEstipulado, finalidade);
    }, [finalidade]);

    return (
        <div className='form-container' style={{ backgroundColor: "lightgray", textAlign: "center" }}>
            <br />
            <div>
                <label>
                    Introduza o valor Estipulado para o imóvel:
                </label>
            </div>
            <div>
                <NumericFormat
                    required
                    placeholder={" "}
                    onValueChange={(values) => {
                        const { value } = values;
                        handleInputChange(value);
                    }}
                    style={{
                        textAlign: "center",
                    }}
                    value={valorEstipulado}
                    thousandSeparator={'.'}
                    decimalSeparator = {','}
                    decimalScale={1}
                />
            </div>
            <div>
                <br />
                <p><b>Valor IPRA: {ipraCalculado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MZN</b></p>
            </div>
            <br />
        </div>
    )
}

export default ValEstipulado;